import { FunctionComponent, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfigContext } from '../../../context';
import { getOrganisationDomain, IconLabel } from '../../../shared';

import classes from './Description.module.scss';

export const Description: FunctionComponent = () => {
  const { t, i18n } = useTranslation();

  const { href } = { ...useContext(ConfigContext).config.elements.leaderBoard };

  const orgDomain = useMemo(() => getOrganisationDomain(), []);

  const descriptionKey = `leaderBoard.${orgDomain}-description`;

  if (!i18n.exists(descriptionKey)) {
    return null;
  }

  return (
    <div className={classes['description']}>
      <IconLabel iconId={'info'} color={'#FFC600'} singleColor nonClickable />
      <div>{t(descriptionKey)}</div>
      {href && (
        <a
          className={classes['description__link']}
          href={href}
          target={'_blank'}
          rel={'noreferrer'}
        >
          {t('leaderBoard.find-out-more')}
        </a>
      )}
    </div>
  );
};
